export const eva_constants = {
  EVA_THEME: 'eva',
  MYLIVETV_THEME: 'mylivetv',

  HOST_MYLIVE: 'mylive',

  ACCOUNT_TYPE_TAG: 'account.type',
  ACCOUNT_DISPLAYNAME_TAG: 'account.displayname',
  ACCOUNT_TOPICS_TAG: 'account.topics',
  ACCOUNT_CONFIG_TAG: 'account.config',
  SESSION_CONFIG_TAG: 'session.config'
};



// WEBPACK FOOTER //
// ./src/app/eva_constants.ts